{
  "app": {
    "name": "3ojo"
  },
  "nav": {
    "admin": "Admin",
    "arcana": "Arcana",
    "readings": "Readings",
    "horoscope": "Horoscope",
    "dreams": "Dreams",
    "account": "Account",
    "settings": "Settings",
    "back": "Back",
    "home": "Home"
  },
  "common": {
    "continue": "Continue",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved",
    "loading": "Loading…",
    "retry": "Try again",
    "signIn": "Sign in",
    "signOut": "Sign out",
    "comingSoon": "Coming soon",
    "upgrade": "Upgrade to access",
    "offline": "You're offline",
    "error": "Something went wrong"
  },
  "home": {
    "actions": "Get started",
    "browseArcana": "Browse Arcana",
    "newReading": "New Reading",
    "allReadings": "See all",
    "todaysHoroscope": "Today's Horoscope",
    "cardOfTheDay": "Card of the day",
    "learnMore": "Learn more",
    "readFullHoroscope": "Read the full horoscope",
    "openHoroscope": "Open the horoscope",
    "news": "News",
    "newsKind": {
      "update": "Update",
      "post": "Blog",
      "callout": "Get involved"
    }
  },
  "decks": {
    "title": "Choose a deck",
    "subtitle": "Meanings are written against the Rider-Waite-Smith. Other decks borrow or diverge from it.",
    "cardCount": "{count} cards",
    "selected": "Selected"
  },
  "arcana": {
    "searchPlaceholder": "Filter cards — try \"3\", \"tres\", \"moon\"",
    "searchHint": "Search works in English and Spanish, whichever language you're reading in.",
    "noResults": "No cards match \"{query}\".",
    "clearSearch": "Clear",
    "resultCount": "{count} of 78",
    "reversed": "Reversed",
    "keywords": "Keywords",
    "meaning": "Meaning",
    "reversedMeaning": "Reversed",
    "inDepth": "In depth",
    "unlockInDepth": "Unlock the in-depth meaning",
    "unlockBlurb": "Twenty years of notes on this card, beyond the summary above.",
    "yourNotes": "Your notes",
    "addNotes": "Add your own notes",
    "notesPlaceholder": "What this card means to you, what it showed up for, what you noticed…",
    "notesPending": "Offline. Will save when you reconnect",
    "notesSynced": "Saved",
    "alternateArt": "Other art",
    "seeAlso": "See also",
    "translationPending": "Long-form Spanish is still being written. Showing English for now.",
    "translationPendingShort": "English text"
  },
  "reading": {
    "title": "Readings",
    "subtitle": "Draw one card, or three, or five.",
    "spread1": "One card",
    "spread3": "Three cards",
    "spread5": "Five cards",
    "spread1Blurb": "A single focus.",
    "spread3Blurb": "What brought this, where you are, where it goes.",
    "spread5Blurb": "The full picture, with what helps and what's in the way.",
    "questionLabel": "What's on your mind?",
    "questionPlaceholder": "A question, a theme, or nothing at all",
    "questionOptional": "Optional",
    "draw": "Draw",
    "drawing": "Drawing…",
    "consulting": "The Oracle is reading…",
    "synthesis": "The Oracle",
    "newReading": "New reading",
    "history": "Past readings",
    "noHistory": "No readings yet.",
    "lockedCard": "Unlock this card",
    "lockedBlurb": "Unlock the 3rd card plus custom insights by the Oracle.",
    "dailyDoneTitle": "Today's reading is done",
    "dailyLimit": "You've had your one three-card reading with the Oracle for today. Come back tomorrow, or upgrade for unlimited readings, every layout, and deeper insights.",
    "upgradeForLayouts": "Upgrade to unlock more layouts",
    "upgradeNudge": "This is the short version. Upgrading unlocks one- and five-card layouts, longer Oracle readings, and the full meanings behind every card.",
    "aiOffline": "The Oracle needs a connection. Your cards and their meanings are here regardless.",
    "quotaExceeded": "You've used this month's Oracle allowance. Card meanings still work as normal.",
    "tapToReveal": "Tap a card to turn it over.",
    "tapToOpen": "Tap a turned card to read it in full.",
    "turnCard": "Turn over card {n}: {position}",
    "openCard": "Read {name}",
    "learnMore": "Learn more about this in the Arcana study",
    "askOracle": "Ask the Oracle",
    "askAgain": "Ask the Oracle again",
    "contextLabel": "Any additional context?",
    "contextPlaceholder": "Anything that's come up since you drew",
    "revealFirst": "Turn over a card, then ask the Oracle.",
    "revealMore": "Turn over another card to ask the Oracle again.",
    "oracleDone": "Every card is turned and read.",
    "revealedOf": "{count} of {total} cards",
    "closeCard": "Close",
    "backToReading": "Back to the reading",
    "positions": {
      "1": ["The card"],
      "3": ["What brought this", "Where you stand", "Where it leads"],
      "5": ["The heart of it", "What's behind it", "What's in the way", "What helps", "Where it leads"]
    }
  },
  "horoscope": {
    "title": "Horoscope",
    "readingFor": "Reading for {date}",
    "notGenerated": "No horoscope has been generated yet.",
    "notGeneratedBlurb": "These are generated on a schedule, not on demand — check back soon.",
    "loadError": "Could not load the horoscope.",
    "changeSign": "Change your sign in Settings",
    "otherSigns": "Other signs"
  },
  "dreams": {
    "title": "Dream Interpretation",
    "subtitle": "Share the details of your dream and we'll help you understand it.",
    "inputLabel": "Your dream",
    "inputPlaceholder": "Share the details of your dream and we'll help you understand it",
    "submitHint": "Ctrl+Enter (or the button) to submit. Enter starts a new line.",
    "submit": "Interpret",
    "comingSoon": "Enhanced dream interpretation coming soon",
    "interpretation": "Interpretation",
    "interpreting": "Consulting the Oracle…",
    "upgradeRequired": "Upgrade to paid tier to get access",
    "aboutTitle": "How this works",
    "aboutBody": "The Oracle reads your dream through a Jungian lens — archetypes, the shadow, and the collective unconscious — as a prompt for reflection, not a prediction."
  },
  "auth": {
    "title": "Sign in",
    "blurb": "Whether it's your first time or you're returning, enter your email and we'll send you a login token.",
    "emailLabel": "Email",
    "emailPlaceholder": "you{'@'}example.com",
    "sendCode": "Send me a code",
    "sending": "Sending…",
    "codeLabel": "Six-digit code",
    "codeSent": "If that address can receive mail, a code is on its way.",
    "verify": "Sign in",
    "verifying": "Signing in…",
    "resend": "Send another code",
    "wrongCode": "That code isn't right.",
    "expired": "That code has expired. Request a new one.",
    "checkEmail": "Check your email",
    "differentEmail": "Use a different address",
    "whatIs": "What's 3ojo?"
  },
  "account": {
    "title": "Account",
    "signedInAs": "Signed in as",
    "tier": "Plan",
    "tiers": {
      "guest": "Guest",
      "free": "Intuitive",
      "mystic": "Mystic",
      "oracle": "Oracle",
      "gifted": "Gifted"
    },
    "tierBlurb": {
      "guest": "Browsing without an account. Meanings and a daily card are yours.",
      "free": "Card meanings, keywords, and one three-card reading a day with a short note from the Oracle.",
      "mystic": "The full app, billed monthly.",
      "oracle": "The full app, bought once. Thank you for being an early supporter.",
      "gifted": "The full app, on the house."
    },
    "upgradeTitle": "Get the full app",
    "upgradeBlurb": "In-depth meanings, your own notes, five-card spreads, and the Oracle.",
    "planMystic": "$3.33 / month",
    "planMysticDetail": "$2.99 plus tax",
    "planOracle": "$7.99 once",
    "planOracleDetail": "Lifetime access · one-time payment, plus tax",
    "earlyAccess": "Limited time. This is the lowest price we will ever offer: Oracle will never cost less than this. It is an early-access guarantee for our earliest supporters.",
    "redirecting": "Taking you to checkout…",
    "choosePlan": "Choose",
    "cancelSubscription": "Cancel subscription",
    "cancelWarning": "Cancelling ends access immediately, not at the end of the month.",
    "cancelled": "Subscription cancelled.",
    "usage": "Oracle usage this month",
    "usageOf": "{used} of {budget} tokens",
    "billingUnavailable": "Payments aren't configured on this server yet.",
    "signOutNote": "You can always sign back in with your email."
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "languageBlurb": "Card filtering works in both languages whichever you choose.",
    "switchLanguage": "Switch to {language}",
    "defaultDeck": "Default deck",
    "zodiacSign": "Your sign",
    "zodiacSignBlurb": "Sets which sign the Horoscope tab shows.",
    "reversals": "Reversed cards",
    "reversalsOn": "Include reversed cards",
    "reversalsLockedBlurb": "Reversed cards are always on for Intuitive accounts.",
    "reversalFrequency": "How often",
    "frequency": {
      "very-low": "Very low (1 in 8)",
      "low": "Low (1 in 4)",
      "natural": "Natural (1 in 2)"
    },
    "quickDraw": "Skip the question step",
    "quickDrawBlurb": "Go straight to the cards.",
    "shareInsights": "Share readings to improve 3ojo",
    "shareInsightsBlurb": "Off by default. Your readings are always saved to your account; this decides whether they may also be used to improve 3ojo.",
    "offline": "Offline",
    "downloadArt": "Save all card art for offline",
    "downloadArtBlurb": "About 5MB. Meanings already work offline.",
    "downloading": "Saving {done} of {total}…",
    "downloaded": "All card art is available offline.",
    "update": "Update available",
    "updateNow": "Reload to update"
  },
  "install": {
    "title": "Install 3ojo",
    "blurb": "Add it to your home screen for offline access.",
    "action": "Install"
  }
}
